import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "醫師報告",
    isNumber: true,
    isSum: true,
  },
];

export const CaseStatus = {
  label: "案件狀態",
  key: "CaseStatus",
  path: "AtriumFibrillation/CaseStatus",
  api: "TCS_V_HeartSS01",
  render: (options) => <Diagram.AtriumFibrillation.CaseStatus {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "",
    },
  ],
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "匯入日期", type: "date" },
  ],
  dateRangeColumns: [
    { label: "篩檢日期", key: "篩檢日期" },
    { label: "匯入日期", key: "匯入日期" },
  ],
  levelColumns,
  columns: [],
};
